import { Check, Copy } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import styles from './CopyButton.module.css';

interface CopyButtonProps {
  value: string;
}

export const CopyButton = ({ value }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  // Genuine side effect: clear the pending reset timeout on unmount so it never calls setCopied on an unmounted component.
  useEffect(() => () => clearTimeout(resetTimeoutRef.current), []);

  const handleCopy = async () => {
    if (copied) {
      return;
    }
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      resetTimeoutRef.current = setTimeout(() => setCopied(false), 1500);
    } catch {
      // writeText rejects on denied permission / insecure context — leave the button idle rather than flashing a false "Copied".
    }
  };

  return (
    <button type="button" onClick={handleCopy} className={styles.copyButton}>
      {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
      {copied ? 'Copied' : 'Copy'}
    </button>
  );
};
